import { UtmParams } from '@utils'

import {
  NOT_COIN_CLAIM_AVAILABLE_LS_KEY,
  RECHARGE_DROP_IS_AVAILABLE_LS_KEY,
  UTM_NOT_COIN_CLAIM_PARAM,
  UTM_RECHARGE_DROP_PARAM,
} from '../constants'
import { ClaimRewardAvailableLsKey, UtmParamKey } from '../type'

const onCheckUtmParam =
  (param: UtmParamKey, lsKey: ClaimRewardAvailableLsKey) =>
  (params: UtmParams) => {
    const utmCampaign = params.utm_campaign

    if (utmCampaign === param) {
      localStorage.setItem(lsKey, 'true')
    }
  }

export const onCheckRechargeDropUtmParam = onCheckUtmParam(
  UTM_RECHARGE_DROP_PARAM,
  RECHARGE_DROP_IS_AVAILABLE_LS_KEY
)

export const onCheckNotCoinClaimUtmParam = onCheckUtmParam(
  UTM_NOT_COIN_CLAIM_PARAM,
  NOT_COIN_CLAIM_AVAILABLE_LS_KEY
)
